import config from '../views/chart/config/chart_api.js';
import PathUri from '@/utils/path_uri';
import axios from '@/plugins/http/axios.js';

const _pathUri = new PathUri(config.port, config.context);

export const service = {
  getResultsHappiness: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/statistics/emotionsToday`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
    })
  },

  getResultsWeeklyChart: (idGroup, idEmpresa, idUsuario, startDate, endDate) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/statistics/weekly?startDate=${startDate}&endDate=${endDate}`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
    })
  },

  getResultsMonthlyChart: (idGroup, idEmpresa, idUsuario, monthDate) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/statistics/monthly?monthDate=${monthDate}`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
    })
  },

  getResultsAnnualChart: (idGroup, idEmpresa, idUsuario, yearDate) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/statistics/annually?yearDate=${yearDate}`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
    })
  },

  postEmailSendHapinnesWeekly: (idGroup, idEmpresa, idUsuario, data) => {
    return axios({
      method: 'post',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/statistics/sendReport?startDate=${data.startDate}&endDate=${data.endDate}`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
      responseType: 'text'
    })
  },

  postEmailSendHapinnesMonthly: (idGroup, idEmpresa, idUsuario, data) => {
    return axios({
      method: 'post',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/statistics/sendReport?month=${data.monthDate}`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
      responseType: 'text'
    })
  },

  getCompanyConfig: (idGroup, idEmpresa, idUsuario, companyId) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/parametro/empresa/${companyId}`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      }
    })
  },

  putCompanySurveyConfig: (idGroup, idEmpresa, idUsuario, companyId, data) => {
    return axios({
      method: 'put',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/parametro/empresa/${companyId}/encuesta`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario,
        'Content-Type': 'application/json'
      },
      data: data
    })
  },

  putCompanyRaffleConfig: (idGroup, idEmpresa, idUsuario, companyId, data) => {
    return axios({
      method: 'put',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/parametro/empresa/${companyId}/sorteo`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario,
        'Content-Type': 'application/json'
      },
      data: data
    })
  },

  getWhiteStarValues: (idGroup, idEmpresa, idUsuario, companyId) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/parametro/empresa/${companyId}/white-star-values`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      }
    })
  }

}